<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="静养圈编号" prop="cattle_slaughter_rest_sn">
              <Input placeholder="请输入静养圈编号" class="perW30" v-model="formData.cattle_slaughter_rest_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="静养圈规模" prop="num">
              <InputNumber placeholder="请输入静养圈规模" class="perW30" v-model="formData.num"></InputNumber>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="静养圈位置" prop="location">
              <Input placeholder="请输入静养圈位置" class="perW60" v-model="formData.location"></Input>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submitFormData">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {cattleSlaughterRestDetailApi, cattleSlaughterRestSaveApi } from '@/api/cattleFarm/cattleSlaughterRest'

export default {
  name: 'cattleSlaughterRestEdit',
  data() {
    return {
      formData: {
        cattle_slaughter_rest_id: 0,
        cattle_slaughter_rest_sn: '',
        num: 0,
        location: '',
      },
      ruleValidate: {
        cattle_slaughter_rest_sn: [
          {required: true, message: '请输入静养圈编号', trigger: 'blur'}
        ],
        num: [
          {type: 'number', required: true, message: '请输入静养圈规模', trigger: 'blur'},
          {type: 'number', message: '请输入数字', trigger: 'change'},
          {type: 'integer', message: '请输入整数', trigger: 'change'},
          {type: 'integer', min: 0, message: '最小为0', trigger: 'change'},
        ],
        location: [
          {required: true, message: '请输入静养圈位置', trigger: 'blur'}
        ],
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submitFormData() {
      // 验证表单数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          // 验证失败 停止提交
          this.$Message.error('请检查输入内容!');
          return false;
        } else {
          // 验证通过 请求接口
          cattleSlaughterRestSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      cattleSlaughterRestDetailApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 数字转换
        this.formData.num = parseInt(this.formData.num)

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
